module.exports = __webpack_public_path__ + "static/city_icon_121-e220312b32beec5701305d4c895629bb.png";